/**
 * Auth Callback Page
 * 
 * Handles OAuth callback from Supabase
 */

import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { LoadingScreen } from '../ui/loading-screen';

export default function AuthCallback() {
  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error);
          // Redirect to login using absolute URL to stay on same domain
          window.location.href = `${window.location.origin}/login?error=auth_failed`;
          return;
        }

        if (data.session) {
          // Successfully authenticated, redirect to dashboard using absolute URL
          window.location.href = `${window.location.origin}/dashboard`;
        } else {
          // No session, redirect to login using absolute URL
          window.location.href = `${window.location.origin}/login`;
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        // Redirect to login using absolute URL to stay on same domain
        window.location.href = `${window.location.origin}/login?error=auth_failed`;
      }
    };

    handleAuthCallback();
  }, []);

  return (
    <LoadingScreen />
  );
}
